var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageBreakImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 770.63,
    height: 484.944,
    viewBox: "0 0 770.63 484.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49.764 -90.978)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.301 526.194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.412,321.137H70.746a2,2,0,1,1,0-3.991h50.665a2,2,0,1,1,0,3.991Z",
    transform: "translate(-68.751 -317.146)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(577.863 350.854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.435,229.645h-1.447a2.17,2.17,0,1,0-4.339,0H324.2a3.618,3.618,0,1,1,7.235,0Z",
    transform: "translate(-324.2 -226.027)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(583.039 266.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.125,185.859h-1.449a2.17,2.17,0,1,0-4.339,0H326.89a3.618,3.618,0,1,1,7.235,0Z",
    transform: "translate(-326.89 -182.241)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341.285 527.574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.119,353.291H201.258l1.168-2.771c4.516-10.713,4.982-19.884,4.3-30.36l-.139-2.121,58.058-.177.014,1.986c.05,6.772,1.882,22.153,4.639,30.843ZM207.2,349.3h57.539a151.52,151.52,0,0,1-4.022-27.435l-49.89.154C211.3,331.31,210.731,339.762,207.2,349.3Z",
    transform: "translate(-201.258 -317.863)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.461 328.135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.817,417.624c-52.28,0-94.63-.285-96.489-.949-4.474-1.6-10.324-7.8-10.4-12.194-.169-9.527-.579-22.5-1.053-37.524-1.434-45.292-3.393-107.324-.851-141.65a11.911,11.911,0,0,1,11.806-11.086h.2l301.406.448a11.885,11.885,0,0,1,11.634,11.713c.231,10.026.558,20.273.885,30.66,1.382,43.484,2.807,88.453-2.009,130.974-.19,1.676-.273,3.529-.36,5.446-.406,8.921-.91,20.026-12.41,22.3C440.553,416.866,329.007,417.624,243.817,417.624Zm-96.964-200.2a8.708,8.708,0,0,0-8.63,8.117c-2.53,34.156-.573,96.09.854,141.311.477,15.035.887,28.02,1.056,37.566.05,2.777,4.69,7.953,8.273,9.231,6.418,1.31,289.781.343,297.147-1.043,9.029-1.784,9.435-10.686,9.827-19.3.091-1.994.179-3.918.375-5.663,4.792-42.287,3.368-87.138,1.992-130.51-.329-10.393-.654-20.65-.887-30.685a8.684,8.684,0,0,0-8.471-8.58L147,217.429Z",
    transform: "translate(-133.793 -214.221)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.757 338.585)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.576,220.026,150.6,219.653c-5.107-.077-9.394,3.425-9.777,8-3.183,38.009,1.155,117.313,1.8,149.23.062,3.112,5.14,7.776,8.8,8.931,4.3,1.36,274.175.333,280.77-.818,11.846-2.069,9.829-14.2,10.824-21.962,5.619-43.9,2.167-91.616,1.049-134.553C443.934,223.832,439.753,220.1,434.576,220.026Z",
    transform: "translate(-139.663 -219.651)",
    fill: "#b6d0fb",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.48 559.254)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.031,349H191.871c-4.69,0-7.141-3.687-7.141-7.332s2.452-7.341,7.141-7.341h118.16c4.69,0,7.143,3.689,7.143,7.332S314.721,349,310.031,349Zm-118.16-11.463a4.132,4.132,0,0,0,0,8.255h118.16a4.132,4.132,0,0,0,0-8.255Z",
    transform: "translate(-184.73 -334.326)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.349 512.11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.459 4.124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.93,311.97h0",
    transform: "translate(-145.406 -311.97)",
    fill: "#415b91",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.591,318.075c5.307,0,5.315-8.248,0-8.248s-5.315,8.248,0,8.248Z",
    transform: "translate(-143.608 -309.827)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.626 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.459 4.124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.57,311.97h0",
    transform: "translate(-154.046 -311.97)",
    fill: "#415b91",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.231,318.075c5.307,0,5.315-8.248,0-8.248s-5.315,8.248,0,8.248Z",
    transform: "translate(-152.248 -309.827)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.251 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.459 4.124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.21,311.97h0",
    transform: "translate(-162.686 -311.97)",
    fill: "#415b91",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.871,318.075c5.307,0,5.315-8.248,0-8.248s-5.315,8.248,0,8.248Z",
    transform: "translate(-160.888 -309.827)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(373.833 332.638)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.622 1.934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.261,217.566h0",
    transform: "translate(-219.016 -217.566)",
    fill: "#415b91",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.04,220.429c2.49,0,2.494-3.868,0-3.868s-2.492,3.868,0,3.868Z",
    transform: "translate(-218.173 -216.561)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(664.86 514.657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.873,362.583H371.158l15.66-51.433h9.4Z",
    transform: "translate(-371.158 -311.151)",
    fill: "#b6d0fb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 51.433)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.444,
    height: 5.876,
    fill: "#b6d0fb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.364 38.575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.073,331.2l-3.915,12.858h40.715L407.958,331.2Z",
    transform: "translate(-371.158 -331.197)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.194 12.858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.227,330.691h25.055l-3.915-12.858H379.142Z",
    transform: "translate(-375.227 -317.833)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(716.178 506.141)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.49,372.219h9.035V337.237H460.9v34.982h9.035V337.237H479.5V309.305h-7.632v-2.581H458.706v2.581H417.621v-2.581H404.456v2.581h-8.378v27.931h9.412Zm71.1-60v.117l-5.569,21.979h-9.937l5.6-22.1Zm-25.918,22.1H440.73l5.6-22.1h9.937Zm-20.348,0H420.38l5.6-22.1h9.939Zm-24.689-22.1h9.937l-5.6,22.1h-9.937Z",
    transform: "translate(-396.078 -306.725)",
    fill: "#b6d0fb"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.915 186.656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.405,183.711,192.113,181a1.4,1.4,0,0,0,0-1.988l-2.359-2.353a1.993,1.993,0,0,1-.314-2.225l1.92-4.665a1.994,1.994,0,0,1,1.8-1.353H196.5a1.405,1.405,0,0,0,1.4-1.4v-3.837a1.4,1.4,0,0,0-1.4-1.4h-3.337a2,2,0,0,1-1.8-1.349l-1.92-4.663a2,2,0,0,1,.314-2.23l2.359-2.353a1.394,1.394,0,0,0,0-1.98l-2.708-2.719a1.405,1.405,0,0,0-1.984,0l-2.361,2.359a2,2,0,0,1-2.221.323l-4.67-1.924a2,2,0,0,1-1.347-1.8v-3.337a1.41,1.41,0,0,0-1.4-1.407H171.59a1.411,1.411,0,0,0-1.407,1.407v3.337a2,2,0,0,1-1.347,1.8l-4.67,1.924a1.994,1.994,0,0,1-2.221-.323l-2.363-2.355a1.389,1.389,0,0,0-1.976,0l-2.717,2.715a1.4,1.4,0,0,0,0,1.98l2.357,2.353a2,2,0,0,1,.319,2.23l-1.92,4.663a2,2,0,0,1-1.8,1.349H150.5a1.4,1.4,0,0,0-1.4,1.4v3.837a1.406,1.406,0,0,0,1.4,1.4h3.341a2,2,0,0,1,1.8,1.353l1.92,4.665a1.99,1.99,0,0,1-.319,2.225l-2.357,2.353a1.406,1.406,0,0,0,0,1.988l2.717,2.708a1.386,1.386,0,0,0,1.976,0l2.363-2.355a1.984,1.984,0,0,1,2.225-.316l4.666,1.92a1.987,1.987,0,0,1,1.347,1.8V188.1a1.407,1.407,0,0,0,1.407,1.4h3.829a1.406,1.406,0,0,0,1.4-1.4V184.76a1.987,1.987,0,0,1,1.347-1.8l4.67-1.92a1.98,1.98,0,0,1,2.221.316l2.361,2.355A1.4,1.4,0,0,0,189.405,183.711ZM173.5,176.3a11.2,11.2,0,1,1,11.2-11.2A11.2,11.2,0,0,1,173.5,176.3Z",
    transform: "translate(-149.099 -140.699)",
    fill: "#b6d0fb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.525 41.976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.755,174.131l-.683-2.273a.876.876,0,0,0-1.085-.585l-1.974.6a1.233,1.233,0,0,1-1.314-.483l-1.988-2.411a1.246,1.246,0,0,1-.2-1.38l.974-1.82a.876.876,0,0,0-.348-1.182l-2.1-1.12a.869.869,0,0,0-1.176.358l-.979,1.82a1.245,1.245,0,0,1-1.262.591l-3.113-.314a1.228,1.228,0,0,1-1.12-.827l-.6-1.978a.861.861,0,0,0-1.081-.575l-2.275.679a.878.878,0,0,0-.583,1.091l.6,1.974a1.229,1.229,0,0,1-.487,1.309l-2.415,1.992a1.239,1.239,0,0,1-1.378.2l-1.822-.978a.863.863,0,0,0-1.174.356l-1.126,2.088a.875.875,0,0,0,.356,1.18l1.822.983a1.225,1.225,0,0,1,.591,1.259l-.31,3.11a1.224,1.224,0,0,1-.829,1.12l-1.978.6a.865.865,0,0,0-.581,1.083l.687,2.271a.867.867,0,0,0,1.087.581l1.978-.6a1.241,1.241,0,0,1,1.3.479l1.988,2.417a1.251,1.251,0,0,1,.208,1.382l-.979,1.82a.881.881,0,0,0,.36,1.18l2.09,1.118a.875.875,0,0,0,1.178-.354l.981-1.824a1.231,1.231,0,0,1,1.26-.593l3.108.316a1.236,1.236,0,0,1,1.126.831l.6,1.972a.868.868,0,0,0,1.085.581l2.273-.687a.877.877,0,0,0,.587-1.08l-.6-1.978a1.232,1.232,0,0,1,.473-1.31l2.417-1.986a1.248,1.248,0,0,1,1.382-.212l1.82.978a.865.865,0,0,0,1.18-.354l1.122-2.094a.872.872,0,0,0-.36-1.178l-1.822-.979a1.218,1.218,0,0,1-.587-1.253l.316-3.121a1.237,1.237,0,0,1,.824-1.12l1.98-.6A.872.872,0,0,0,197.755,174.131Zm-8.7,6.512a6.938,6.938,0,1,1-2.836-9.393A6.939,6.939,0,0,1,189.055,180.642Z",
    transform: "translate(-168.08 -162.512)",
    fill: "#b6d0fb"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.705 280.095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.478,193.247h-62.73a2,2,0,1,1,0-3.991h62.73a2,2,0,1,1,0,3.991Z",
    transform: "translate(-208.752 -189.256)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.395 308.592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.652,208.056H124.322a2,2,0,1,1,0-3.991h101.33a2,2,0,0,1,0,3.991Z",
    transform: "translate(-122.326 -204.065)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(675.24 362.548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.128,236.095H376.8a2,2,0,1,1,0-3.991H478.128a2,2,0,1,1,0,3.991Z",
    transform: "translate(-374.804 -232.104)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.764 571.931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M818.4,344.9H51.76a2,2,0,1,1,0-3.991H818.4a2,2,0,1,1,0,3.991Z",
    transform: "translate(-49.764 -340.914)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(506.469 259.022)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.815,178.3a16.1,16.1,0,0,0-13.884,24.24l.266.448-16.3,16.293a2.855,2.855,0,0,0-.8,1.853,3.537,3.537,0,0,0,1.23,2.475,3.9,3.9,0,0,0,2.723,1.318,3.3,3.3,0,0,0,1.918-.652l16.255-16.262.45.267a16.1,16.1,0,1,0,8.14-29.981Zm0,27.41a11.316,11.316,0,1,1,0-22.632h0a11.316,11.316,0,1,1,0,22.632Z",
    transform: "translate(-287.099 -178.305)",
    fill: "#b6d0fb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.752 15.466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.962,189.325h11.656v-2.983H299.962Z",
    transform: "translate(-299.962 -186.342)",
    fill: "#b6d0fb"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.32 414.535)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.706,416.811a2,2,0,0,1-2-2v-153.7a2,2,0,0,1,3.993,0v153.7A2,2,0,0,1,148.706,416.811Z",
    transform: "translate(-146.711 -259.12)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.719 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.268,416.811a2,2,0,0,1-2-2v-153.7a2,2,0,1,1,3.991,0v153.7A2,2,0,0,1,167.268,416.811Z",
    transform: "translate(-165.273 -259.12)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.425,268.57H148.706a2,2,0,0,1,0-3.991h35.719a2,2,0,1,1,0,3.991Z",
    transform: "translate(-146.711 -264.579)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.425,277.7H148.706a2,2,0,0,1,0-3.991h35.719a2,2,0,1,1,0,3.991Z",
    transform: "translate(-146.711 -273.704)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 45.623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.425,286.82H148.706a2,2,0,0,1,0-3.991h35.719a2,2,0,1,1,0,3.991Z",
    transform: "translate(-146.711 -282.829)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 63.183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.425,295.945H148.706a2,2,0,0,1,0-3.991h35.719a2,2,0,1,1,0,3.991Z",
    transform: "translate(-146.711 -291.954)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 80.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.425,305.07H148.706a2,2,0,0,1,0-3.991h35.719a2,2,0,1,1,0,3.991Z",
    transform: "translate(-146.711 -301.079)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 98.301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.425,314.2H148.706a2,2,0,0,1,0-3.991h35.719a2,2,0,1,1,0,3.991Z",
    transform: "translate(-146.711 -310.204)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 115.861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.425,323.32H148.706a2,2,0,0,1,0-3.991h35.719a2,2,0,1,1,0,3.991Z",
    transform: "translate(-146.711 -319.329)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 133.418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.425,332.444H148.706a2,2,0,1,1,0-3.991h35.719a2,2,0,1,1,0,3.991Z",
    transform: "translate(-146.711 -328.453)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.792 412.225)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.883 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.427,269.681a2,2,0,0,1-2-2v-7.77a2,2,0,0,1,3.991,0v7.77A2,2,0,0,1,123.427,269.681Z",
    transform: "translate(-121.432 -257.92)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.178,263.93H121.41a2,2,0,0,1,0-3.991h7.768a2,2,0,0,1,0,3.991Z",
    transform: "translate(-119.414 -259.939)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(363.264 134.286)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.695,125.245a2,2,0,0,1-2-2v-7.772a2,2,0,0,1,3.991,0v7.772A2,2,0,0,1,216.695,125.245Z",
    transform: "translate(-214.699 -113.484)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.446,119.495h-7.768a2,2,0,1,1,0-3.993h7.768a2,2,0,0,1,0,3.993Z",
    transform: "translate(-212.68 -115.502)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.59 539.563)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.978,331.6a2,2,0,0,1-.548-.077l-7.472-2.132a2,2,0,0,1,1.095-3.839l7.472,2.132a2,2,0,0,1-.547,3.916Z",
    transform: "translate(-243.51 -325.48)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.893,335.552a2.068,2.068,0,0,1-.548-.075,2,2,0,0,1-1.372-2.467l2.134-7.472a2,2,0,1,1,3.837,1.095L248.81,334.1A1.993,1.993,0,0,1,246.893,335.552Z",
    transform: "translate(-244.896 -324.093)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.335 304.855)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.578,209.636a2.016,2.016,0,0,1-.548-.077l-7.47-2.134a2,2,0,1,1,1.095-3.837l7.472,2.132a2,2,0,0,1-.548,3.916Z",
    transform: "translate(-223.11 -203.511)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.494,213.588a1.938,1.938,0,0,1-.548-.079,2,2,0,0,1-1.372-2.467l2.134-7.47a2,2,0,1,1,3.837,1.095l-2.134,7.472A2,2,0,0,1,226.494,213.588Z",
    transform: "translate(-224.497 -202.123)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(348.362 200.897)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.723,
    cy: 27.723,
    r: 27.723,
    transform: "translate(0 39.207) rotate(-45)",
    fill: "#b6d0fb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.635 17.636)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.804 0.803)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.768,
    cy: 20.768,
    r: 20.768,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.671,200.407a21.571,21.571,0,1,1,21.571-21.571A21.6,21.6,0,0,1,235.671,200.407Zm0-41.536a19.965,19.965,0,1,0,19.965,19.965A19.987,19.987,0,0,0,235.671,158.871Z",
    transform: "translate(-214.1 -157.264)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.404 27.829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.7,174.742a.8.8,0,0,1-.8-.8V163.365a.8.8,0,1,1,1.607,0v10.574A.8.8,0,0,1,225.7,174.742Z",
    transform: "translate(-224.893 -162.561)",
    fill: "#405b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.084,169.663H225.7a.8.8,0,0,1,0-1.607h12.389a.8.8,0,1,1,0,1.607Z",
    transform: "translate(-224.893 -168.056)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.963 19.964)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.523,159.294a.82.82,0,1,1-.82-.82A.819.819,0,0,1,226.523,159.294Z",
    transform: "translate(-224.884 -158.474)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.45 5.396)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.846 18.423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.278,169.687a.82.82,0,1,1,.82-.82A.82.82,0,0,1,235.278,169.687Z",
    transform: "translate(-234.458 -168.048)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.45 31.45)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.423 36.847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.884,178.442a.82.82,0,1,1,.82.82A.819.819,0,0,1,224.884,178.442Z",
    transform: "translate(-224.884 -177.622)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.397 31.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.354,175.057a.82.82,0,1,1,0,1.16A.822.822,0,0,1,218.354,175.057Z",
    transform: "translate(-218.114 -174.817)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.82,
    cy: 0.82,
    r: 0.82,
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.397 5.395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.514,161.519a.82.82,0,1,1-1.16,0A.82.82,0,0,1,219.514,161.519Z",
    transform: "translate(-218.114 -161.278)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.317 27.013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.362,163.744h-11.64a.8.8,0,1,1,0-1.607h11.64a.8.8,0,1,1,0,1.607Z",
    transform: "translate(-239.918 -162.137)",
    fill: "#405b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.362,175.583h-11.64a.8.8,0,1,1,0-1.607h11.64a.8.8,0,1,1,0,1.607Z",
    transform: "translate(-239.918 -173.976)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.368 11.394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.735,169.665H242.992a.8.8,0,1,1,0-1.607h21.743a.8.8,0,1,1,0,1.607Z",
    transform: "translate(-242.188 -168.058)",
    fill: "#405b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(466.676 539.376)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.858,
    height: 12.858,
    transform: "translate(0.999 0.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.274,338.85H266.42V324h14.854Zm-12.858-2h10.863V325.991H268.415Z",
    transform: "translate(-266.42 -323.996)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.686 2.217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.056,326.757h-11.64a.8.8,0,0,1,0-1.609h11.64a.8.8,0,0,1,0,1.609Z",
    transform: "translate(-275.611 -325.148)",
    fill: "#405b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.429,331.335H276.7c-.6,0-1.085-.36-1.085-.8s.487-.8,1.085-.8h15.733c.6,0,1.085.358,1.085.8S293.03,331.335,292.429,331.335Z",
    transform: "translate(-275.611 -329.728)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.158,328.916H276.415a.8.8,0,1,1,0-1.607h21.743a.8.8,0,0,1,0,1.607Z",
    transform: "translate(-275.611 -327.309)",
    fill: "#405b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.152 350.688)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.858,
    height: 12.858,
    transform: "translate(13.856 13.855) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.55,240.795H119.7V225.941H134.55Zm-12.858-2h10.863V227.937H121.692Z",
    transform: "translate(-119.696 -225.941)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.217)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.142,228.7h11.642a.8.8,0,0,0,0-1.607H112.142a.8.8,0,0,0,0,1.607Z",
    transform: "translate(-111.34 -227.093)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.446 8.811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.007,233.279h15.731c.6,0,1.085-.358,1.085-.8s-.485-.8-1.085-.8H110.007c-.6,0-1.087.36-1.087.8S109.407,233.279,110.007,233.279Z",
    transform: "translate(-108.92 -231.672)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.892,230.861h21.745a.8.8,0,0,0,0-1.607H106.892a.8.8,0,0,0,0,1.607Z",
    transform: "translate(-106.09 -229.254)",
    fill: "#405b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(555.592 381.23)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.898 18.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.991,
    height: 171.634,
    fill: "#3f5b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.614 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.559,
    height: 39.539,
    rx: 6.153,
    fill: "#b6d0fb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.424 26.601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.655,257.091l4.212.677c.943.15,1.349-1.291.4-1.443l-4.212-.677c-.941-.152-1.347,1.291-.4,1.443Z",
    transform: "translate(-333.114 -255.636)",
    fill: "#3f5b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.882 17.239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.771,252.441a12.215,12.215,0,0,1,3.308-.116c.958.09.953-1.407,0-1.5a13.673,13.673,0,0,0-3.706.169c-.947.167-.545,1.609.4,1.443Z",
    transform: "translate(-332.832 -250.771)",
    fill: "#3f5b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.465 7.796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.515,248.645l3.229-1.282c.885-.35.5-1.8-.4-1.443l-3.229,1.282c-.885.35-.5,1.8.4,1.443Z",
    transform: "translate(-332.616 -245.864)",
    fill: "#3f5b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.725 27.191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.464,258.2a17.072,17.072,0,0,0,3.229-.768c.906-.312.518-1.757-.4-1.443a17.071,17.071,0,0,1-3.229.768c-.951.133-.547,1.574.4,1.443Z",
    transform: "translate(-313.523 -255.943)",
    fill: "#3f5b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.349,252.306a16.492,16.492,0,0,1,4.062.622.749.749,0,0,0,.4-1.443,18.211,18.211,0,0,0-4.459-.675.749.749,0,0,0,0,1.5Z",
    transform: "translate(-312.627 -250.809)",
    fill: "#3f5b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.508 5.013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.931,245.9l3.233,1.029c.92.294,1.314-1.151.4-1.443q-1.616-.514-3.233-1.031c-.92-.293-1.314,1.153-.4,1.445Z",
    transform: "translate(-313.411 -244.418)",
    fill: "#3f5b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.58 169.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.2,352.988l2.661-22.94h12.972l2.993,22.609Z",
    transform: "translate(-320.204 -330.048)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.669 371.749)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.687 16.337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.584,293.265q24.165-21.848,48.329-43.691c2.386-2.157-1.151-5.677-3.529-3.527l-48.327,43.689c-2.386,2.157,1.151,5.679,3.527,3.529Z",
    transform: "translate(-187.264 -245.376)",
    fill: "#d7e7ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.304 38.621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.967,304.845,268.3,261.155c2.386-2.159-1.151-5.679-3.529-3.529L216.44,301.317c-2.386,2.157,1.151,5.677,3.527,3.527Z",
    transform: "translate(-215.647 -256.956)",
    fill: "#d7e7ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.105,339.9,290.4,241.133c2.3-2.246-1.228-5.773-3.529-3.529q-50.643,49.387-101.29,98.771c-2.3,2.246,1.226,5.771,3.527,3.527Z",
    transform: "translate(-184.828 -236.886)",
    fill: "#d7e7ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(381.25 90.978)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.577 76.656)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.172,
    height: 139.393,
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 130.546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.037,207.5a8.848,8.848,0,1,1-8.848-8.846A8.848,8.848,0,0,1,280.037,207.5Z",
    transform: "translate(-262.341 -198.654)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.707 145.915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.492,229.8a7.306,7.306,0,0,1-7.264-7.93,1.171,1.171,0,0,1,2.342,0A5.624,5.624,0,0,0,267,226.013a5.545,5.545,0,0,0,3.489,1.449,5.987,5.987,0,1,0,0-11.973,1.17,1.17,0,0,1-1.17-1.172v-6.5a1.171,1.171,0,1,1,2.342,0v5.415a8.329,8.329,0,0,1-1.172,16.576Z",
    transform: "translate(-263.228 -206.641)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 241.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.183 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.288,225.933a1.086,1.086,0,0,1,.027-2.144l47.9-7.055a1.085,1.085,0,1,1,.316,2.148l-47.894,7.055A1.034,1.034,0,0,1,243.288,225.933Z",
    transform: "translate(-242.389 -216.723)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.218,241.873a1.106,1.106,0,0,1-.317-.108l-44.04-22.994a1.085,1.085,0,1,1,1-1.924l44.042,22.994a1.086,1.086,0,0,1-.689,2.032Z",
    transform: "translate(-267.278 -216.722)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.984)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.644,
    height: 91.139,
    rx: 5.869,
    transform: "translate(15.603 0) rotate(9.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.891,332.86a13.25,13.25,0,0,1-2.271-.2L233.151,312.426A13.207,13.207,0,0,1,222.4,297.147l11.592-66.712a13.227,13.227,0,0,1,15.275-10.753L365.736,239.92A13.213,13.213,0,0,1,376.493,255.2L364.9,321.909A13.238,13.238,0,0,1,351.891,332.86ZM247,222.48a10.232,10.232,0,0,0-10.06,8.469l-11.592,66.712a10.216,10.216,0,0,0,8.317,11.815l116.472,20.236a10.224,10.224,0,0,0,11.813-8.315l11.592-66.712a10.216,10.216,0,0,0-8.315-11.815L248.754,222.63A10.277,10.277,0,0,0,247,222.48Z",
    transform: "translate(-221.866 -219.151)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.985 12.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.249,
    height: 77.03,
    rx: 3.75,
    transform: "matrix(0.985, 0.171, -0.171, 0.985, 13.515, 0.328)",
    fill: "#b6d0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.252,321.981a9.225,9.225,0,0,1-1.555-.135L233.1,302.28a8.979,8.979,0,0,1-7.31-10.384l10.624-61.147a8.984,8.984,0,0,1,10.385-7.31L359.395,243a8.99,8.99,0,0,1,7.312,10.385l-10.624,61.145a8.988,8.988,0,0,1-8.831,7.447Zm-1.045-3.085a5.986,5.986,0,0,0,6.924-4.872l10.626-61.149a5.993,5.993,0,0,0-4.872-6.922L246.29,226.388a6,6,0,0,0-6.926,4.874L228.74,292.409a5.992,5.992,0,0,0,4.874,6.924Z",
    transform: "translate(-225.657 -223.305)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.71 71.975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.42,281.811l29.271-26.827,16.2,34.728Z",
    transform: "translate(-258.249 -253.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.647,291.816l-49.355-8.575,31.77-29.117Zm-45.011-9.847,41.584,7.228L290.4,257.433Z",
    transform: "translate(-259.292 -254.125)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.833 41.182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.343,286.544l51.894-47.561,28.72,61.568Z",
    transform: "translate(-228.173 -237.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.713,302.656l-84.5-14.682,54.392-49.851ZM233.554,286.7l76.732,13.334-27.337-58.6Z",
    transform: "translate(-229.215 -238.123)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.197 42.356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.3,247.752a7.257,7.257,0,1,1-5.908-8.392A7.257,7.257,0,0,1,296.3,247.752Z",
    transform: "translate(-280.892 -238.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.643,255.246a8.416,8.416,0,0,1-1.432-.123,8.238,8.238,0,1,1,1.432.123Zm-.029-14.517a6.259,6.259,0,1,0,6.179,7.332h0a6.269,6.269,0,0,0-6.179-7.332Z",
    transform: "translate(-281.371 -238.733)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.38 71.966)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108.775,
    height: 11.97,
    fill: "#b6d0fb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.361)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.213)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.038,410.343H343.927V91.06h36.111Zm-32.54-3.573h28.968V94.632H347.5Z",
    transform: "translate(-343.927 -91.06)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,126.183H344.162V90.978h35.207Zm-31.587-3.62h27.968V94.6H347.782Z",
    transform: "translate(-344.162 -90.978)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "translate(0 31.586) rotate(-45)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452 31.586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,142.6H344.162V107.392h35.207Zm-31.587-3.62h27.968V111.012H347.782Z",
    transform: "translate(-344.162 -107.392)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "translate(0 31.586) rotate(-45)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452 63.171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,159.011H344.162V123.806h35.207Zm-31.587-3.618h27.968V127.426H347.782Z",
    transform: "translate(-344.162 -123.806)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 31.588)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452 94.759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,175.426H344.162V140.221h35.207Zm-31.587-3.62h27.968V143.839H347.782Z",
    transform: "translate(-344.162 -140.221)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "translate(0 31.586) rotate(-45)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452 126.344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,191.84H344.162V156.635h35.207Zm-31.587-3.62h27.968V160.255H347.782Z",
    transform: "translate(-344.162 -156.635)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 31.587)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452 157.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,208.254H344.162V173.049h35.207Zm-31.587-3.618h27.968V176.669H347.782Z",
    transform: "translate(-344.162 -173.049)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 31.588)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452 189.517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,224.667H344.162v-35.2h35.207Zm-31.587-3.618h27.968V193.082H347.782Z",
    transform: "translate(-344.162 -189.464)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.532 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 31.587)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452 221.103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,241.083H344.162V205.878h35.207Zm-31.587-3.62h27.968V209.5H347.782Z",
    transform: "translate(-344.162 -205.878)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.529)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 31.587)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452 252.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,257.5H344.162V222.292h35.207Zm-31.587-3.62h27.968V225.912H347.782Z",
    transform: "translate(-344.162 -222.292)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.532 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 31.587)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452 284.274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.369,273.911H344.162V238.706h35.207Zm-31.587-3.618h27.968V242.326H347.782Z",
    transform: "translate(-344.162 -238.706)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.531 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.62,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-44.999)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.528 0.533)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.62,
    transform: "translate(0 31.58) rotate(-44.989)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 31.11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.029,142.35H376.824V107.145h35.205Zm-31.587-3.62H408.41V110.763H380.442Z",
    transform: "translate(-376.824 -107.145)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.532 0.526)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "translate(0 31.592) rotate(-45.011)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.53 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.613,142.35h-35.2V107.145h35.2Zm-31.586-3.62H392V110.763H364.028Z",
    transform: "translate(-360.41 -107.145)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.532 0.526)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "translate(0 31.592) rotate(-45.011)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.529 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.2,142.35H343.995V107.145H379.2Zm-31.586-3.62h27.968V110.763H347.615Z",
    transform: "translate(-343.995 -107.145)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.786,142.35H327.581V107.145h35.205Zm-31.586-3.62h27.966V110.763H331.2Z",
    transform: "translate(-327.581 -107.145)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.53 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "translate(0 31.586) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.53 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.372,142.35H311.167V107.145h35.205Zm-31.587-3.62h27.968V110.763H314.785Z",
    transform: "translate(-311.167 -107.145)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.529 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.67,
    height: 3.619,
    transform: "translate(0 31.586) rotate(-45)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.529 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.957,142.35H294.752V107.145h35.205Zm-31.586-3.62h27.968V110.763H298.372Z",
    transform: "translate(-294.752 -107.145)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.734,142.1H280.147a1.81,1.81,0,0,1-1.278-3.09l31.586-31.586,2.557,2.559-28.5,28.5h26.469L342.04,107.42l2.559,2.559-31.587,31.586A1.8,1.8,0,0,1,311.734,142.1Z",
    transform: "translate(-278.338 -107.42)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.116 0.529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.619,
    height: 44.67,
    transform: "translate(0 2.559) rotate(-45)",
    fill: "#415b91"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.213 319.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.115,292.184H343.927v-35.2h36.188Zm-32.469-3.618H376.4V260.6H347.647Z",
    transform: "translate(-343.927 -256.981)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.678,291.4,344.21,259.815l2.63-2.559,32.468,31.586Z",
    transform: "translate(-344.21 -257.256)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.841,291.4l-2.63-2.56,32.467-31.586,2.631,2.559Z",
    transform: "translate(-344.21 -257.256)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.213 445.785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.115,357.841H343.927v-35.2h36.188Zm-32.469-3.618H376.4V326.256H347.647Z",
    transform: "translate(-343.927 -322.638)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.678,357.058,344.21,325.472l2.63-2.559L379.309,354.5Z",
    transform: "translate(-344.21 -322.913)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.841,357.058l-2.63-2.56,32.467-31.585,2.631,2.559Z",
    transform: "translate(-344.21 -322.913)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.213 348.032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.115,307.044H343.927V271.839h36.188Zm-32.469-3.618H376.4V275.459H347.647Z",
    transform: "translate(-343.927 -271.839)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.678,306.26,344.21,274.674l2.63-2.559L379.309,303.7Z",
    transform: "translate(-344.21 -272.115)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.841,306.26l-2.63-2.56,32.467-31.586,2.631,2.559Z",
    transform: "translate(-344.21 -272.115)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.213 379.619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.115,323.457H343.927v-35.2h36.188Zm-32.469-3.618H376.4V291.872H347.647Z",
    transform: "translate(-343.927 -288.254)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.678,322.674,344.21,291.088l2.63-2.559,32.468,31.586Z",
    transform: "translate(-344.21 -288.529)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.841,322.674l-2.63-2.56,32.467-31.586,2.631,2.559Z",
    transform: "translate(-344.21 -288.529)",
    fill: "#415b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.213 411.205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.115,339.871H343.927v-35.2h36.188Zm-32.469-3.618H376.4V308.286H347.647Z",
    transform: "translate(-343.927 -304.668)",
    fill: "#415b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.678,339.088,344.21,307.5l2.63-2.559,32.468,31.586Z",
    transform: "translate(-344.21 -304.943)",
    fill: "#415b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.545 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.841,339.088l-2.63-2.56,32.467-31.586,2.631,2.559Z",
    transform: "translate(-344.21 -304.943)",
    fill: "#415b91"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.261 276.564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.86,188.976",
    transform: "translate(-149.968 -185.984)",
    fill: "#405b91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.249,193.408c3.852,0,3.86-5.987,0-5.987s-3.858,5.987,0,5.987Z",
    transform: "translate(-151.357 -187.421)",
    fill: "#405b91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(569.887 214.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.558,156.481",
    transform: "translate(-318.667 -153.489)",
    fill: "#405b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.947,160.913c3.852,0,3.86-5.987,0-5.987s-3.858,5.987,0,5.987Z",
    transform: "translate(-320.055 -154.926)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(704.158 428.234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.388,267.8h1.332",
    transform: "translate(-388.393 -264.801)",
    fill: "#405b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.827,272.225h1.332a2.993,2.993,0,0,0,0-5.986h-1.332a2.993,2.993,0,0,0,0,5.986Z",
    transform: "translate(-389.832 -266.239)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.852 472.139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.327,290.61",
    transform: "translate(-88.435 -287.618)",
    fill: "#405b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.716,295.041c3.852,0,3.858-5.986,0-5.986s-3.858,5.986,0,5.986Z",
    transform: "translate(-89.824 -289.055)",
    fill: "#405b91"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(412.897 184.763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.975,141.271",
    transform: "translate(-237.083 -138.277)",
    fill: "#405b91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.364,145.7c3.852,0,3.858-5.988,0-5.988s-3.858,5.988,0,5.988Z",
    transform: "translate(-238.472 -139.715)",
    fill: "#405b91"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageBreakImage);
export default __webpack_public_path__ + "static/media/page-break-image.5a98e8fdbe411235a7610fa1f5f0e083.svg";
export { ForwardRef as ReactComponent };